export var DEFAULT_Y = 0; // 默认的 y 的值
// 偏移之后，间距
export var MARGIN_RATIO = 1 / 2;
export var DODGE_RATIO = 1 / 2;
// 散点分开之后，距离边界的距离
export var GAP = 0.05;
//# sourceMappingURL=constant.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_adjust@0.2.2@@antv/adjust/esm/constant.js
// module id = null
// module chunks = 